import deepmerge from 'deepmerge';
import {v4 as uuidv4} from 'uuid';

import arrayUtils from './arrayUtils';

type TGuid = () => string;
type TTimeout = (ms: number) => Promise<void>;
type TRunFunction = (func: ((...args: any[]) => void) | null | undefined, arg?: any | any[]) => void;
type TscrollTop = (yCoord?: number) => void;
type Tdebounce = (func: (...args: any[]) => any, delay: number) => void;

const guid: TGuid = () => uuidv4();

const timeout: TTimeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mergeDeep = deepmerge;

const scrollTop: TscrollTop = (yCoord = 0) => window.scrollTo({top: yCoord});

const runFunction: TRunFunction = (func, arg) => {
    const args = arrayUtils.toArray(arg);

    if (typeof func === 'function') {
        args ? func(...args) : func();
    }
};

// eslint-disable-next-line
const deepClone = (data: any) => JSON.parse(JSON.stringify(data));

const debounce: Tdebounce = (func, delay) => {
    let timerId: ReturnType<typeof setTimeout>;

    return (...args: any) => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export default {
    guid,
    mergeDeep,
    scrollTop,
    runFunction,
    timeout,
    deepClone,
    debounce,
};
